angular.module('lf.common')

.directive('errorMessageFor', function () {
  return {
    restrict: 'EA',
    require: '^form',
    link: function ($scope, $el, $attrs, FormCtrl) {

      var $field = $el.parent().find('[ng-model], input').eq(0);
      var name = $field.attr('name');
      var type = $attrs.errorMessageFor;
      var isInput = $field[0].tagName === 'INPUT';
      var parentHasErrorClass = 'has-error';

      $el.hide();

      $scope.$watch(function () {
        var field = FormCtrl[name];
        var pristine = field.$pristine;
        var formTouched = FormCtrl.$touched;
        var invalid = field.$error[type];

        if (formTouched) {
          return field.$editing ? false :  invalid;
        } else {
          return field.$editing ? false : (!pristine && invalid);
        }
      }, function (invalid) {
        var field = FormCtrl[name];
        var pristine = field.$pristine;
        var formTouched = FormCtrl.$touched;
        var hasErrors = field.$invalid;
        var editing = field.$editing;

        if (invalid && !editing) {
          $el.show();
        } else {
          $el.hide();
        }

        if (!editing && hasErrors && (formTouched || !pristine || invalid)) {
          $el.parent().addClass(parentHasErrorClass);
        } else {
          $el.parent().removeClass(parentHasErrorClass);
        }

      });
    }
  }
});
